module.exports = __webpack_public_path__ + "static/media/banner-photo360@2x.7d71bf30.webp";